import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/layout/Layout";
import ScrollToTop from "@/components/common/ScrollToTop";
import ScrollToTopFab from "@/components/common/ScrollToTopFab";
import Analytics from "@/components/common/Analytics";
import Home from "@/pages/Home";
import Stays from "@/pages/Stays";
import PropertyDetail from "@/pages/PropertyDetail";
import Collection from "@/pages/Collection";
import Location from "@/pages/Location";
import GuestLove from "@/pages/GuestLove";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Shoots from "@/pages/Shoots";
import Booking from "@/pages/Booking";
import BookingConfirmation from "@/pages/BookingConfirmation";
import { Privacy, Terms } from "@/pages/Policies";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import {
  SouthDelhiStays, GK1Stays, GurgaonStays, NearDhanMill,
  LuxuryStaysDelhi, RomanticStaysDelhi, CinematicStaysDelhi,
  GroupStaysDelhi, ExtendedStaysDelhi, ExperientialDesignStays,
  DesignLedSouthDelhi, DirectBookingDelhiNCR, AirbnbAlternativesSouthDelhi,
  PrivateStayCouplesDelhiNCR, ShootFriendlyStaysDelhiNCR,
} from "@/pages/SeoPages";

function LayoutWrapper() {
  return <Layout><Outlet /></Layout>;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ScrollToTopFab />
          <Analytics />
          <Toaster richColors position="top-center" />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route element={<LayoutWrapper />}>
              <Route path="/" element={<Home />} />
              <Route path="/stays" element={<Stays />} />
              <Route path="/stays/:slug" element={<PropertyDetail />} />
              <Route path="/collections/:slug" element={<Collection />} />
              <Route path="/locations/:slug" element={<Location />} />
              <Route path="/guest-love" element={<GuestLove />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shoots" element={<Shoots />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/booking/confirmation" element={<BookingConfirmation />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* SEO long-tail landing pages */}
              <Route path="/south-delhi-stays" element={<SouthDelhiStays />} />
              <Route path="/gk1-stays" element={<GK1Stays />} />
              <Route path="/gurgaon-stays" element={<GurgaonStays />} />
              <Route path="/near-dhan-mill" element={<NearDhanMill />} />
              <Route path="/luxury-stays-delhi" element={<LuxuryStaysDelhi />} />
              <Route path="/romantic-stays-delhi" element={<RomanticStaysDelhi />} />
              <Route path="/cinematic-stays-delhi" element={<CinematicStaysDelhi />} />
              <Route path="/group-stays-delhi" element={<GroupStaysDelhi />} />
              <Route path="/extended-stays-delhi" element={<ExtendedStaysDelhi />} />
              <Route path="/experiential-design-stays" element={<ExperientialDesignStays />} />

              {/* Editorial SEO landing pages — added in Iteration 22 */}
              <Route path="/design-led-stays-south-delhi" element={<DesignLedSouthDelhi />} />
              <Route path="/direct-booking-delhi-ncr" element={<DirectBookingDelhiNCR />} />
              <Route path="/airbnb-alternatives-south-delhi" element={<AirbnbAlternativesSouthDelhi />} />
              <Route path="/private-stay-couples-delhi-ncr" element={<PrivateStayCouplesDelhiNCR />} />
              <Route path="/shoot-friendly-stays-delhi-ncr" element={<ShootFriendlyStaysDelhiNCR />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
